import { render, staticRenderFns } from "./Contadores.vue?vue&type=template&id=01f5cf3a&scoped=true"
import script from "./Contadores.vue?vue&type=script&lang=js"
export * from "./Contadores.vue?vue&type=script&lang=js"
import style0 from "./Contadores.vue?vue&type=style&index=0&id=01f5cf3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f5cf3a",
  null
  
)

export default component.exports